import { useLocation } from 'react-router-dom';

export const useIdQuestion = (id?: string) => {
	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
	return queryParams.get(id || 'idEncuesta') || '';
};
